module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-ipad3-c16537543e55a202e13a6917077f8b65.png";